(function () {
    'use strict';
    var controllerId = 'ordineDetail';
    angular.module('app').controller(controllerId, ['$scope', 'common', 'datacontext', '$uibModalInstance', 'ordine', '$translate', ordineDetail]);

    function ordineDetail($scope, common, datacontext, $uibModalInstance, ordine, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        var logError = getLogFn(controllerId, 'logError');
        $scope.loading = false;
        $scope.ordine = ordine;
        $scope.item = {};
        getBonifico();        
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.inviaFattura = function () {
            $scope.loading = true;
            datacontext.ordine_sendMail($scope.ordine.Id).then(function(data){
                if(!data)
                    logSuccess($translate.instant('EmailInviata'));
                else
                    logError($translate.instant('ErroreEmail'));

                $scope.loading = false;
            });
        }

        function getBonifico() {
            return datacontext.contoCorrente_getAll().then(function (items) {
                return $scope.item.bonifico = items[0];
            });
        }
    }
})();